<template>
  <div
    v-if="bandeau != 0 && show"
    class="bandeau"
    :class="{
      incomplet: bandeau == 11,
      moderation: bandeau == 12,
      passidy: bandeau == 1 || bandeau == 4,
      bserenite: bandeau == 2
    }"
  >
    <router-link class="link" :to="linkDestination">
      <div class="grille">
        <img v-if="bandeau < 10" class="pass pass1" src="/assets/images/pass.png" />
        <div v-if="bandeau == 1" class="renouv">
          Renouveler Mon Pass <span v-html="$store.state.siteConst.coloredName"></span>
        </div>

        <div v-if="bandeau == 4" class="renouv">
          Découvrez le Pass <span v-html="$store.state.siteConst.coloredName"></span>
          <p class="detailsSere">
            Lisez et repondez aux messages de tous les membres d'Idylive en illimité !
          </p>
        </div>

        <div v-if="bandeau == 2" class="renouv">
          Découvrez le Pass <span class="serenite">Sérénité</span>
          <p class="detailsSere">
            Accusés de réception des messages, mode invisible, filtre de contacts...
          </p>
        </div>

        <div v-if="bandeau == 11" class="renouv">
          Profil incomplet !
          <p class="detailsSere">
            Pour communiquer sur Idylive
            <strong>veuillez renseigner votre annonce personnelle ou envoyer une photo.</strong>
          </p>
        </div>

        <div v-if="bandeau == 12" class="renouv">
          Profil en attente de modération...
          <p class="detailsSere">
            Vous pourrez communiquer sur Idylive une fois votre profil vérifié.
          </p>
        </div>

        <img v-if="bandeau < 10" class="pass pass2" src="/assets/images/pass.png" />
      </div>
    </router-link>
    <img @click="hide" class="cross" src="/assets/icons/cross.png" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true
    };
  },

  methods: {
    hide(e) {
      e.stopPropagation();
      this.$store.commit("setBandeau", 0);
    }
  },

  computed: {
    linkDestination() {
      if (this.bandeau >= 11) {
        return { name: "Profil" };
      }

      if (this.bandeau == 2) {
        return { name: "Serenite" };
      }
      return { name: "Pass" };
    },

    bandeau() {
      return this.$store.state.bandeau;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.bandeau {
  right: 0px;
  left: 0px;
  top: $menu_height;
  z-index: 300;
  max-width: $app_width;
  margin: 0 auto;
  padding-left: 10px;
  padding-right: 10px;
  position: absolute;
  cursor: pointer;
  display: grid;
  align-items: center;
  min-height: 105px;
}

.link {
  display: block;
}

.pass {
  filter: brightness(100);
}

.detailsSere {
  font-size: 14px;
  font-weight: normal;
  font-style: italic;
}

.passidy {
  background: linear-gradient(to right, rgb(19, 132, 224), white);
}

.incomplet {
  background: linear-gradient(to right, rgb(224, 77, 19), white);
}

.moderation {
  background: linear-gradient(to right, rgb(220, 224, 19), white);
}

.bserenite {
  background: linear-gradient(to right, rgb(114, 163, 134), white);
}

.renouv {
  font-size: 30px;
  font-weight: bold;
}

.grille {
  padding-top: 10px;
  padding-bottom: 10px;
  justify-content: center;
  display: grid;
  grid-template-columns: min-content max-content min-content;
  grid-gap: 100px;
  align-content: center;
  align-items: center;
}

.incomplet .grille,
.moderation .grille {
  display: block;
}

.pass2 {
  transform: scaleX(-1);
}

.cross {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  z-index: 2000;
}

@media screen and (max-width: $app_width) {
  .bandeau {
    top: $menu_height_smallapp;
  }
}

@media screen and (max-width: $mobile_mode) {
  .hideBandeauMobile {
    display: none;
  }

  .bandeau .grille {
    grid-gap: 25px;

    img {
      width: 30px;
    }

    .renouv {
      font-size: 18px;
      font-weight: bold;
    }
  }

  .bandeau {
    min-height: 83px;
  }
}
</style>
